<div class="topbar-group">
  <ng-container *ngIf="icon$ | async as _icon">
    <div style="fill: #d81020" class="mr-5" [innerHTML]="_icon | SafeHTML"></div>
  </ng-container>
  <!--end::Page Icon-->
  <!--begin::Page Title-->
  <div class="topbar-tenant">
    <ng-container *ngIf="(title$ | async) as _title">
      <ng-container *ngIf="(user$ | async) as _user">
        <h1 class="text-dark font-weight-bold my-1">
          {{ _title }}
        </h1>
        <div style="display: flex; align-items: center;">
          <mat-icon class="person-pin-icon tenant-name-badge-icon">person_pin</mat-icon>
          <span class="badge badge-warning font-weight-bold px-2 py-1 tenant-name-badge">
            {{ _user.tenant.name ?? _user.tenant.tenancyName }}
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="pl-10 mt-2">
    <div class="sc-incident-export d-flex align-items-center" *ngIf="requireExportIconsPage">
      <div class="text-right">
        <label for="exportCSVBtn">&nbsp;</label>
        <div class="input-group export-btns">
          <button type="button" [disabled]="(isExportingCSV$ | async) || (isExportingIncidentReportCSV$ | async)"
            class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-csv" id="exportCSVBtn"
            title="Export to CSV" (click)="triggerExport(1, requireExportIconsPage)" matTooltip="Export to CSV">
            <ng-container *ngIf="!((isExportingCSV$ | async) || (isExportingIncidentReportCSV$ | async)); else loading">
              <i class="fa fa-file-o" style="margin-right: 0px;"></i>
            </ng-container>
          </button>
        </div>
      </div>
      <div class="text-right">
        <label for="exportXLSBtn">&nbsp;</label>
        <div class="input-group export-btns">
          <button type="button" [disabled]="(isExportingExcel$ | async) || (isExportingIncidentReportExcel$ | async)"
            class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-xls" id="exportXLSBtn"
            title="Export to Excel" (click)="triggerExport(2, requireExportIconsPage)" matTooltip="Export to Excel">
            <ng-container *ngIf="!((isExportingExcel$ | async) || (isExportingIncidentReportExcel$ | async)); else loading">
              <i class="fa fa-file-excel-o" style="margin-right: 0px;"></i>
            </ng-container>
          </button>
        </div>
      </div>
      <div class="text-right">
        <label for="exportPDFBtn">&nbsp;</label>
        <div class="input-group export-btns">
          <button type="button" [disabled]="(isExportingPDF$ | async) || (isExportingIncidentReportPDF$ | async)"
            class="btn btn-md btn-icon btn-icon-md btn-circle mx-1 btn-export-pdf" id="exportPDFBtn"
            title="Export to PDF" (click)="triggerExport(3, requireExportIconsPage)" matTooltip="Export to PDF">
            <ng-container *ngIf="!((isExportingPDF$ | async) || (isExportingIncidentReportPDF$ | async)); else loading">
              <i class="fa fa-file-pdf-o" style="margin-right: 0px;"></i>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="topbar-group">

  <div class="pt-1" *ngIf="hasDashboardPermission">
    <sc-tenant-statistics class=""></sc-tenant-statistics>
  </div>

  <ng-container *ngIf="user$ | async as _user">
    <!--begin::User-->
    <div class="dropdown sc-account-tour" #dropDown ngbDropdown placement="bottom-right" (click)="getLinkedTenantsList()">
      <div ngbDropdownToggle class="topbar-item nav-link" data-offset="0px,0px" tabindex="0" role="button">
        <span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline text-break truncate-text">
          <span *ngIf="_user.isImpersonated">
            <mat-icon color="primary">reply</mat-icon>
          </span>
          {{ _user.userName }}
        </span>
      </div>
      <div ngbDropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-lg dropdown-menu-anim-up">

        <form>
          <div class="card card-custom gutter-b shadow-light">
            <!--begin::Header-->
            <div class="p-6 bgi-size-cover bgi-no-repeat rounded-top bg-dark">
              <p class="text-white">{{_user.tenant.name ?? _user.tenant.tenancyName}}</p>
              <h4 class="text-white">{{ _user.name }} {{ _user.surname }}</h4>
              <p class="text-white m-0 flex-grow-1 text-break">{{ _user.emailAddress }}</p>
            </div>
            <!--end::Header-->
            <div class="card-body p-5" *ngIf="_user.isImpersonated">
              <div class="text-left">
                <a class="d-flex flex-row align-items-center btn" (click)="unimpersonate()">
                  <ng-container *ngIf="!(loggingOut$ | async)">
                    <mat-icon class="pr-3" color="primary">reply</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="(loggingOut$ | async)">
                    <span class="spinner spinner-primary spinner-track spinner-sm pr-7"></span>
                  </ng-container>
                  Back to my account
                </a>
              </div>
            </div>

            <div class="overflow-auto switch-account">
              <ng-container *ngIf="linkedUser?.length > 1">
              <div class="search-bar">
                <div class="position-sticky">
                  <form [formGroup]="linkedTenantForm">
                    <input matInput type="text" class="form-control input-group" formControlName="userId" placeholder="Search Tenant">
                    <mat-icon class="position-absolute top-0 right-0 translate-middle-y search-icon">search</mat-icon>
                  </form>
                </div>
              </div>
              </ng-container>
            
              <div class="options-container">
                <ng-container *ngIf="!isFilterApplied; else filteredOptions" class="scrollable-select">
                  <ng-container *ngFor="let user of linkedUser">
                    <button type="button" class="btn btn-light d-flex align-items-center w-100"  (click)="switchTenant(user.userId)" *ngIf="user.userId != _user.id">
                      <mat-icon class="mx-1 person-pin-icon">person_pin</mat-icon>
                      <span class="text-left">{{ user.tenantName ?? user.tenancyName }}</span>
                      <span *ngIf="switchTenantLoadingMap[user.userId]" class="spinner spinner-primary spinner-track spinner-sm ml-auto mr-5"></span>
                    </button>
                  </ng-container>
                </ng-container>
            
                <ng-template #filteredOptions class="scrollable-select">
                  <ng-container *ngFor="let user of filtered$ | async">
                    <button type="button" class="btn btn-light d-flex align-items-center w-100"  (click)="switchTenant(user.userId)" *ngIf="user.userId != _user.id">
                      <mat-icon class="mx-1 person-pin-icon">person_pin</mat-icon>
                      <span class="text-left">{{ user.tenantName ?? user.tenancyName }}</span>
                      <span *ngIf="switchTenantLoadingMap[user.userId]" class="spinner spinner-primary spinner-track spinner-sm ml-auto mr-5"></span>
                    </button>
                  </ng-container>
                </ng-template>
          
                <div *ngIf="(filtered$ | async)?.length === 0 && isFilterApplied" class="no-tenants-found">
                  No tenants found.
                </div>
              </div>
            </div>

            <!--begin::Logout-->
            <div class="card-footer p-5">
              <div class="text-right">
                <button *ngIf="!isLinkedUsers" type="button" class="btn btn-pill btn-primary text-dark px-10 text-weight-bold"
                  (click)="changePassword(dropDown)">
                  Change Password
                </button>
                <button type="button" class="btn btn-pill btn-primary text-dark px-10 ml-2 text-weight-bold"
                  (click)="logout()">
                  Logout
                </button>
              </div>
            </div>
            <!--end::Logout-->
          </div>
        </form>
      </div>
    </div>
    <!--end::User-->
  </ng-container>

</div>

<ng-template #loading>
  <span class="spinner spinner-light spinner-track spinner-lg spinner-center"></span>
</ng-template>